export function showPartialsFixed(partial, partialShow, partialHide) {
  const partialSelected = document.querySelectorAll(partial);
  const documentHeight = document.documentElement.scrollHeight; // Altura total da página
  const windowHeight = window.innerHeight; // Altura da janela de visualização

  partialSelected.forEach((partial) => {
    if (window.innerWidth >= 992) {

      const scrollThreshold = documentHeight > windowHeight + 120 ? 120 : 0;

      if (window.scrollY > scrollThreshold) {
        partial.classList.add(partialShow);
        partial.classList.remove(partialHide);

      } else {
        if (partial.classList.contains(partialShow)) {
          partial.classList.add(partialHide);
          partial.classList.remove(partialShow);
        }
      }

    } else {

      const scrollThreshold = documentHeight > windowHeight + 150 ? 150 : 0;

      if (window.scrollY > scrollThreshold) {
        partial.classList.add(partialShow);
        partial.classList.remove(partialHide);
      } else {
        if (partial.classList.contains(partialShow)) {
          partial.classList.add(partialHide);
          partial.classList.remove(partialShow);
        }
      }
    }
  });
}
